import React from 'react';
import { Heart, Mail, ArrowRight, Shield } from 'lucide-react';

export default function Give() {
  return (
    <div id="give" className="py-28 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-50/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-primary-600 uppercase tracking-wider">Support Our Mission</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">Partner With Us</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-primary-500 to-blue-500 mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Your generous support enables us to continue our mission of reaching souls across the world. All funds donated go towards the work of the Lord and our missionary partners worldwide.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="group bg-white p-8 md:p-10 rounded-3xl border border-gray-100 shadow-card hover:shadow-card-hover transition-all duration-500 hover:-translate-y-1">
            <div className="w-14 h-14 bg-gradient-to-br from-primary-600 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-primary-600/20 group-hover:scale-110 transition-transform duration-300">
              <Heart className="text-white" size={24} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Give Online</h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Support our ministry securely through PayPal. You can make a one-time gift or set up recurring donations to help us continue our mission.
            </p>
            <a
              href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=GBZPBS7SFSZ2C&ssrt=1737651681681"
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn inline-flex items-center justify-center w-full bg-primary-600 text-white px-6 py-4 rounded-xl hover:bg-primary-700 transition-all duration-200 font-semibold hover:shadow-lg hover:shadow-primary-600/20 active:scale-[0.98]"
            >
              Give via PayPal
              <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={18} />
            </a>
            <div className="flex items-center gap-2 mt-4 text-gray-400 text-sm justify-center">
              <Shield size={14} />
              <span>Secure donation via PayPal</span>
            </div>
          </div>

          <div className="group bg-white p-8 md:p-10 rounded-3xl border border-gray-100 shadow-card hover:shadow-card-hover transition-all duration-500 hover:-translate-y-1">
            <div className="w-14 h-14 bg-gradient-to-br from-primary-600 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-primary-600/20 group-hover:scale-110 transition-transform duration-300">
              <Mail className="text-white" size={24} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Give by Mail</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              You can also support our ministry by sending a check. Please make checks payable to:
            </p>
            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 mb-6">
              <p className="font-bold text-gray-900 text-lg">SAVE THE WORLD CHRISTIAN MINISTRY</p>
              <div className="mt-3 pt-3 border-t border-gray-200">
                <p className="text-sm text-gray-500 font-medium uppercase tracking-wide">Mail to:</p>
                <p className="text-gray-700 mt-1 font-medium">
                  PO BOX 1172<br />
                  Elyria, OH 44036
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-500 italic leading-relaxed">
              Your contribution helps us continue our mission of reaching souls and expanding God's kingdom through evangelism worldwide.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <blockquote className="text-lg text-gray-500 italic max-w-2xl mx-auto">
            "Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver."
            <cite className="block mt-2 text-sm not-italic font-medium text-gray-400">- 2 Corinthians 9:7</cite>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
